import { sortBy } from 'lodash';

export const findFileInFolder = (folder, fileId) => {
  if (!fileId) return null;

  let file = null;
  const navigation = [folder];

  folder.children.some((doc) => {
    if (doc.folder) {
      const result = findFileInFolder(doc, fileId);
      if (result && result.file) {
        navigation.push(...result.navigation);
        file = result.file;
        return true;
      }
    } else if (doc.id == fileId) {
      file = doc;
      return true;
    }
  });

  return { file, navigation };
};


export const getFirstFile = (folder) => {
  const files = folder.children.filter(doc => !doc.folder);
  const unlockedFile = files.find(file => !file.locked);

  if (unlockedFile) return unlockedFile;
  return sortBy(files, 'accessLevel')[0] || null;
};

export const findFolderInFolder = (folderToSearch, folderId) => {
  if (!folderId) return null;

  const recursiveSearch = (currentFolder, id) => {
    const navigation = [currentFolder];

    for (const doc of currentFolder.children) {
      if (!doc.folder) continue;

      if (doc.id == id) return { folder: doc, navigation: [...navigation, doc] };

      const result = recursiveSearch(doc, folderId);
      if (result?.folder) {
        return { folder: result.folder, navigation: [...navigation, ...result.navigation] };
      }
    }
  };

  return recursiveSearch(folderToSearch, folderId);
};